// components/FeedTags.jsx — Anamoria SPA
// v1.1 — W2 polish (Sept 10, 2026): the "+N more" overflow is now a link that opens the memory
//   (onOpen); visible chips stay quiet. Falls back to a static span when no onOpen is given.
// v1.0 — W2 member tags (Sept 2026): read-only tag chips on feed cards.
//   Folds a feed entry's tags into one order-preserving, case-insensitively
//   de-duplicated set:
//     - moment entry     → union of entry.pieces[].tags
//     - standalone memory → entry.tags
//   Shows up to MAX_VISIBLE chips, then "+N more". Renders nothing when empty,
//   so untagged cards (and the flag-off / no-tags payload) are byte-identical.
//   READ-ONLY by construction: never edits. Tagging lives on the moment detail.
import styles from './FeedTags.module.css';

export const MAX_VISIBLE = 3;

// Order-preserving, case-insensitive de-dup of the entry's tags.
export function collectTags(entry) {
  const out = [];
  const seen = new Set();
  const push = (t) => {
    if (!t || !t.label) return;
    const key = String(t.label).trim().toLowerCase();
    if (!key || seen.has(key)) return;
    seen.add(key);
    out.push(t);
  };
  if (Array.isArray(entry?.pieces)) {
    for (const p of entry.pieces) (p?.tags || []).forEach(push);
  }
  (entry?.tags || []).forEach(push); // standalone memory entry
  return out;
}

export default function FeedTags({ entry, onOpen }) {
  const tags = collectTags(entry);
  if (tags.length === 0) return null;
  const visible = tags.slice(0, MAX_VISIBLE);
  const overflow = tags.length - visible.length;
  return (
    <div className={styles.row} aria-label="Tags">
      {visible.map((t) => (
        <span key={t.id || t.label} className={styles.chip}>{t.label}</span>
      ))}
      {overflow > 0 && (
        onOpen
          ? <button type="button" className={styles.more} onClick={onOpen}>+{overflow} more</button>
          : <span className={styles.more}>+{overflow} more</span>
      )}
    </div>
  );
}
